module.exports = __webpack_public_path__ + "img/linkedin.58fd3990.svg";